import { Product } from "#products/products.js";
import { ProjectType } from "#signup/signup.js";
//#region src/products/recommendations.ts
const recommendedProductsByProjectType = {
	[ProjectType.Analytics]: [Product.Webhooks, Product.TransfersApi],
	[ProjectType.Defi]: [
		Product.EmbeddedAccounts,
		Product.TokenApi,
		Product.Webhooks
	],
	[ProjectType.Gaming]: [Product.Webhooks, Product.Websockets],
	[ProjectType.Wallet]: [
		Product.EmbeddedAccounts,
		Product.GasManagerApi,
		Product.TokenApi
	],
	[ProjectType.Security]: [Product.Webhooks, Product.TransfersApi],
	[ProjectType.Marketplace]: [
		Product.NftApi,
		Product.Webhooks,
		Product.TokenApi
	],
	[ProjectType.Social]: [
		Product.NftApi,
		Product.Webhooks,
		Product.TokenApi
	],
	[ProjectType.InfraAndTooling]: [Product.Webhooks, Product.TransfersApi],
	[ProjectType.NFTs]: [
		Product.NftApi,
		Product.Webhooks,
		Product.TokenApi
	],
	[ProjectType.Identity]: [
		Product.TokenApi,
		Product.Webhooks,
		Product.TransfersApi
	]
};
const otherProjectRecommendedProducts = [
	Product.TokenApi,
	Product.NftApi,
	Product.Webhooks
];
//#endregion
export { otherProjectRecommendedProducts, recommendedProductsByProjectType };

//# sourceMappingURL=recommendations.js.map